/** Fired by the shell after a task is created. */
export const TASK_CREATED_EVENT = 'QTaskCreated';

/** Fired by the shell after a task is updated, completed, cancelled, or reopened. */
export const TASK_CHANGED_EVENT = 'QTaskChanged';
